import { Page } from '@/core/architecture'

import { UlinkTemplate } from './template'
import { useViewModel } from './viewModel'

export const Ulink: Page = () => {
  const { state, actions } = useViewModel()

  return <UlinkTemplate state={state} />
}
